<template>
  <div>
    <div v-if="short" class="fs-14 d-flex align-items-center">
      {{ isOk ? "Онлайн" : "Оффлайн" }}
      <div
        v-if="humanStatus"
        class="lamp"
        :style="`color:${isOk ? 'green' : 'red'}`"
        :data-text="`Статус онлайн консультаций - ${humanStatus.title}`"
      ></div>
    </div>
    <div v-else class="fs-14">
      Уведомления:
      <span v-if="humanStatus" data-test="websocket-status" :style="`font-weight:700;color:${humanStatus.color}`">{{
        humanStatus.title
      }}</span>
    </div>
    <div v-if="full" class="mt-24">
      <p class="fw-bold">Техническая информация о веб-сокетах</p>
      <ul>
        <li>Канал: {{ Object.keys($echo.connector.channels) }}</li>
        <li>Адрес сервера: {{ $echo.connector.options.wsHost }}:{{ $echo.connector.options.wsPort }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BaseSocketStatus",
  props: {
    short: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["socketStatus"]),
    isTest() {
      return this.$auth && this.$auth.user && this.$auth.user.test;
    },
    humanStatus() {
      const statuses = {
        initialized: { title: "Запуск", color: "#fff" },
        connecting: { title: "Подключение", color: "green" },
        connected: { title: "Подключены", color: "green" },
        unavailable: { title: "Не доступны", color: "red" },
        failed: { title: "Подключение не удалось", color: "red" },
        disconnected: { title: "Отключены", color: "red" },
      };
      return statuses[this.socketStatus] || { title: "Подключение", color: "#fff" };
    },
    isOk() {
      return ["initialized", "connecting", "connected"].includes(this.socketStatus);
    },
  },
};
</script>

<style lang="scss" scoped>
.lamp {
  border-radius: 50%;
  border: 5px solid;
  margin-left: 4px;
  position: relative;
  z-index: 10000;
  &::before {
    position: absolute;
    content: attr(data-text);
    color: #fff;
    background: #000;
    padding: 6px 8px;
    width: 220px;
    top: 100%;
    left: 0;
    margin-top: 5px;
    transform: translateY(5px);
    opacity: 0;
    transition: all 0.3s ease-in;
    border-radius: 5px;
  }
  &:hover:before {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
